const { createEnum } = require("./utils/enum");

const COLLECTION_TYPE = (exports.COLLECTION_TYPE = {
  ADHOC: "A",
  DIRECT_SALES: "D",
  EDI: "E",
  PICKUP: "P",
  SCHEDULED: "S",
  SHIP: "W",
  INTERACT: "I",
});

const COLLECTION_TYPE_DESCRIPTION = (exports.COLLECTION_TYPE_DESCRIPTION = {
  [COLLECTION_TYPE.ADHOC]: "Adhoc",
  [COLLECTION_TYPE.DIRECT_SALES]: "Direct Sales",
  [COLLECTION_TYPE.EDI]: "Edi",
  [COLLECTION_TYPE.PICKUP]: "Pickup",
  [COLLECTION_TYPE.SCHEDULED]: "Scheduled",
  [COLLECTION_TYPE.SHIP]: "MyDPD",
  [COLLECTION_TYPE.INTERACT]: "Interact",
});

exports.COLLECTION_TYPES_ENUM = (createEnum => [
  createEnum(COLLECTION_TYPE.ADHOC),
  createEnum(COLLECTION_TYPE.DIRECT_SALES),
  createEnum(COLLECTION_TYPE.EDI),
  createEnum(COLLECTION_TYPE.PICKUP),
  createEnum(COLLECTION_TYPE.SCHEDULED),
  createEnum(COLLECTION_TYPE.SHIP),
])(type => createEnum(type, COLLECTION_TYPE_DESCRIPTION[type]));

exports.COLLECTION_DASH_TYPE = {
  PEND: "PEND",
  OFC: "OFC",
  CARD: "CARD",
  UNS: "UNS",
  COLL: "COLL",
  FAIL: "FAIL",
  CANC: "CANC",
  WTCH: "WTCH",
};
